export enum FilterOperator {
  Equal,
  NotEqual,
  GreaterThan,
  GreaterThanOrEqual,
  LessThan,
  LessThanOrEqual,
  Like,
  OneOf,
  NotOneOf,
  EmptyOrNull,
  NotEmptyOrNull,
}
